<template>
  <div class="room-config">
    <el-card>
      <div class="room-config-title">房间管理</div>
      <header class="room-config-search">
        <div>
          <span>用户rid:</span>
          <el-input v-model="searchData.ridStr" placeholder="rid(英文,分割传输)" style="width: 200px;"></el-input>
        </div>
        <div>
          <span>渠道:</span>
          <el-select filterable  v-model="searchData.channel" placeholder="请选择">
            <el-option label="All" value=""></el-option>
            <el-option v-for="item in searchList.channelList" :key="item.id" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>开播状态:</span>
          <el-select v-model="searchData.ownerStatus" placeholder="请选择">
            <el-option v-for="item in searchList.ownStatusList" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>状态:</span>
          <el-select v-model="searchData.valid" placeholder="请选择">
            <el-option v-for="item in searchList.validList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>房间类型:</span>
          <el-select v-model="searchData.roomType" placeholder="请选择">
            <el-option v-for="item in searchList.roomTypeList" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>开始时间:</span>
          <el-date-picker v-model="searchData.startDate" type="date" placeholder="选择日期">
          </el-date-picker>
        </div>
        <div>
          <span>结束时间:</span>
          <el-date-picker v-model="searchData.endDate" type="date" placeholder="选择日期">
          </el-date-picker>
        </div>
        <el-button type="primary" @click="getRoomConfigList">查询</el-button>
        <el-button type="success" @click="addDialogShow">新增</el-button>
        
      </header>
      <el-table :data="tableList" style="width: 100%" height="70vh">
        <el-table-column label="房间ID" width="120" prop="roomId"></el-table-column>
        <el-table-column label="主播id" width="100" prop="rid"></el-table-column>
        <el-table-column label="名称" width="140" prop="name"></el-table-column>
        <el-table-column label="渠道" width="180" prop="channel"></el-table-column>
        <el-table-column label="房间类型" width="120" prop="roomType" align="center">
          <template #default="{ row }">
            <span>{{ searchList.roomTypeList.find((item) => item.value == row.roomType).label }}</span>
          </template>
        </el-table-column>
        <el-table-column label="房间状态" width="100" prop="roomValid" align="center">
          <template #default="{ row }">
            {{ row.roomValid === 0 ? '封禁' : '正常' }}
          </template>
        </el-table-column>
        <el-table-column label="是否开播" width="120" prop="ownerStatus" align="center">
          <template #default="{ row }">
            <span>
              <i v-if="row.ownerStatus === 0" class="el-icon-error" style="color: #F56C6C;font-size: 14px;"></i>
              <i v-if="row.ownerStatus === 1" class="el-icon-s-help" style="color: #8bce68;font-size: 14px;"></i>
              <i v-if="row.ownerStatus === 2" class="el-icon-warning" style="color: #E6A23C;font-size: 14px;"></i>
              {{ searchList.ownStatusList.find((item) => item.value == row.ownerStatus).label }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="房间封面" width="180" prop="roomCover" align="center">
          <template #default="{ row }">
            <el-image style="width: 100px; height: 100px" :src="row.roomCover" fit="cover"
              :preview-src-list="[row.roomCover]">
              <div slot="error" class="image-slot">
                无封面
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="房间标题" width="180" prop="roomName"></el-table-column>
        <el-table-column label="房间公告" width="180" prop="roomNotice"></el-table-column>
        <el-table-column label="当前房间在线人数" width="170" prop="currUserCount" align="center"></el-table-column>
        <el-table-column label="本场开播时长" width="150" prop="chapterDuration" align="center">
          <template #default="{ row }">
            {{ row.chapterDuration }} min
          </template>
        </el-table-column>
        <el-table-column label="当前热度值" width="120" prop="currHeat" align="center">
          <template #default="{ row }">
            <i class="el-icon-hot-water" style="color:#F56C6C"></i> {{ row.currHeat }}
          </template>
        </el-table-column>
        <el-table-column label="增量热度值" width="120" prop="increaseHeat" align="center">
          <template #default="{ row }">
            <i class="el-icon-hot-water" style="color:#F56C6C"></i> {{ row.increaseHeat }}
          </template>
        </el-table-column>
        <el-table-column label="置顶权重" width="120" prop="top" align="center"></el-table-column>
        <el-table-column label="开始时间" width="140" prop="startTime" align="center"></el-table-column>
        <el-table-column label="结束时间" width="140" prop="endTime" align="center"></el-table-column>
        <el-table-column label="操作人" width="180" prop="operator"></el-table-column>
        <el-table-column label="状态" width="100" prop="roomValid" align="center">
          <template #default="{ row }">
            {{ row.valid === 0 ? '无效' : '有效' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template #default="{ row }">
            <el-button type="text" size="small" @click="editDialogShow(row)">编辑</el-button>
            <el-button type="text" :class="{ red: row.roomValid == 0 }" size="small" @click="changeRoomStatus(row)">
              {{ row.roomValid == 0 ? '解冻' : '冻结' }}
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="searchData.page"
        @current-change="getRoomConfigList">
      </el-pagination>
    </el-card>
    <RoomConfigDialog v-model="dialog.visible" :is-edit="dialog.isEdit" @submit="submitChange" :data="dialog.data">
    </RoomConfigDialog>
  </div>
</template>

<script>
import { getRoomConfigListReq, changeRoomStatusReq, addRoomConfigReq, updateRoomConfigReq } from '@/api/roomConfigRequest.js'
import RoomConfigDialog from '@/components/RoomConfig/RoomConfigDialog.vue'
export default {
  components: {
    RoomConfigDialog
  },
  data() {
    return {
      dialog: {
        isEdit: false,
        visible: false,
        data: {}
      },
      total: 0,
      searchData: {
        ridStr: '',
        channel: '',
        ownerStatus: -1,
        valid: -1,
        roomType: 0,
        startDate: '',
        endDate: '',
        page: 1
      },
      searchList: {
        channelList: [],
        ownStatusList: [
          { value: -1, label: '全部' },
          { value: 0, label: '已关闭' },
          { value: 1, label: '房间中' },
          { value: 2, label: '已离开' }
        ],
        validList: [
          { value: -1, label: '全部' },
          { value: 0, label: '无效' },
          { value: 1, label: '有效' }
        ],
        roomTypeList: [
          { value: 0, label: '全部' },
          { value: 1, label: '直播' },
          { value: 2, label: '语聊' }
        ]
      },
      tableList: []
    }
  },
  methods: {
    
    getFormData(obj) {
      const formData = new FormData()
      // if(obj.file !== '') {
      //   delete obj.ridStr
      // } else {
      //   delete obj.file
      // }
      Object.keys(obj).forEach(key => {
        const value = obj[key]
        if (Array.isArray(value)) {
          value.forEach((subValue, i) => {
            formData.append(key + `[${i}]`, subValue)
          })
        } else {
          formData.append(key, obj[key])
        }
      })
      formData.append('operator', this.$store.getters.username)
      return formData
    },
    // 打开新增弹窗
    addDialogShow() {
      this.dialog.isEdit = false
      this.dialog.visible = true
    },
    editDialogShow(row) {
      this.dialog.data = row
      this.dialog.isEdit = true
      this.dialog.visible = true
    },
    // 获取渠道列表
    async getChannelList() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.channelList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      if (res.code == 0) {
        this.searchList.channelList = res.data
      }
    },
    // 提交操作（包括新增和修改）
    async submitChange(data) {
      console.log(data);
      let res = null
      if (this.dialog.isEdit) {
        res = await updateRoomConfigReq({
          "roomId": data.roomId,
          "channel": data.channel,
          "roomCover": data.roomCover,
          "roomName": data.roomName,
          "roomNotice": data.roomNotice,
          "increaseHeat": Number(data.increaseHeat),
          "top": Number(data.top),
          "startDateTime": data.startTime,
          "endDateTime": data.endTime,
          "valid": data.valid
        })
      } else {
        res = await addRoomConfigReq(this.getFormData(data))
      }
      if (res.code === 0) {
        this.getRoomConfigList()
        this.dialog.visible = false
      } else {
        this.$message.error(res.msg)
      }

    },
    // 获取房间列表
    async getRoomConfigList() {
      const res = await getRoomConfigListReq(this.searchData)
      if (res.code === 0) {
        this.tableList = res.data.data
        this.total = res.data.total
        this.$message({ type: 'success', message: "查询成功" })
      } else {
        this.$message.error(res.msg)
        this.tableList = []
      }
    },
    // 改变房间状态
    async changeRoomStatus(row) {
      try {
        await this.$confirm('是否改变状态?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await changeRoomStatusReq({ roomId: row.roomId, roomValid: row.roomValid ? 0 : 1 })
        if (res.code === 0) {
          this.$message({ type: 'success', message: "修改成功" })
          this.getRoomConfigList()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {

      }
    }
  },
  mounted() {
    this.getRoomConfigList()
    this.getChannelList()
  }
}
</script>

<style scoped lang="scss">
.room-config {
  &-title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  &-search {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    .el-select,
    .el-input {
      margin-left: 12px;
    }
  }

  :deep(.image-slot) {
    width: 100%;
    height: 100%;
    background-color: #f5f7fa;
    line-height: 100px;
    text-align: center;
  }

  .red {
    color: #F56C6C;
  }
}
</style>